import { observable } from 'mobx';

export type HotelElementGuestResponseArgs = {
  id: number;
  bed_type_description?: string;
  guest_first_name?: string;
  guest_last_name?: string;
  guest_tel?: string;
};

export type HotelElementGuestArgs = {
  id: number;
  bedTypeDescription?: string;
  guestFirstName?: string;
  guestLastName?: string;
  guestTel?: string;
};

export const convertHotelElementGuestResponseToArgs = (response: HotelElementGuestResponseArgs) => {
  const args: HotelElementGuestArgs = {
    id: response.id,
    bedTypeDescription: response.bed_type_description,
    guestFirstName: response.guest_first_name,
    guestLastName: response.guest_last_name,
    guestTel: response.guest_tel
  };
  return args;
};

export default class HotelElementGuest {
  @observable id: number;
  @observable bedTypeDescription?: string;
  @observable guestFirstName?: string;
  @observable guestLastName?: string;
  @observable guestTel?: string;

  constructor(args: HotelElementGuestArgs) {
    this.id = args.id;
    this.bedTypeDescription = args.bedTypeDescription;
    this.guestFirstName = args.guestFirstName;
    this.guestLastName = args.guestLastName;
    this.guestTel = args.guestTel;
  }

  get bedTypeDescriptionOverview() {
    if (!this.bedTypeDescription) {
      return 'ベッドタイプ：-';
    }
    return `ベッドタイプ：${this.bedTypeDescription}`;
  }
}
